import PropTypes from 'prop-types'
import React, { Component } from 'react'
import DropZone from 'react-dropzone'
import { connect } from 'react-redux'
import { animateScroll } from 'react-scroll'

import {
  buyHelper,
  phaseChange,
  reroute,
  storeDumpItForce,
  toggleHelpDocumenti,
} from '../../../actions/Buy'
import {
  findomesticFileUploadDropped,
  findomesticFileUploadRemoved,
  postFindomesticFileUpload,
} from '../../../actions/buy/Documenti'
import { getFindomesticDocumentiClienteV1 } from '../../../actions/buy/Findomestic'
import fbPixel, { FB_EVENTS } from '../../../utils/fbpixel'
import OrderRecoveryBanner from '../../dumb/OrderRecoveryBanner'
import DocumentiHelper from '../../noleggia/dumb/DocumentiHelper'
import triggerDataLayerEvent, { GA_EVENTS } from '../../triggerDataLayerEvent'
import FileUploadErrorMessage from '../dumb/FileUploadErrorMessage'

class DocumentsFindomestic extends Component {
  constructor(props) {
    super(props)
    this.state = {
      hasRejectedFiles: false,
    }
    this.onOpenClick = this.onOpenClick.bind(this)
    this.handleCheckbox = this.handleCheckbox.bind(this)
    this.onDrop = this.onDrop.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.removeFile = this.removeFile.bind(this)
    this.buildListaDocumentiSelezionatiPerUpload =
      this.buildListaDocumentiSelezionatiPerUpload.bind(this)
    this.state.upload_btn_disabled = true
    this.state.counter = 0
    this.state.toTop = false
  }

  componentWillMount() {
    if (!this.props.customer) {
      this.props.reroute('/register')
    } else if (
      !('token' in this.props.customer) ||
      this.props.customer.token === null ||
      this.props.customer.token.length === 0
    ) {
      this.props.reroute('/register')
    }
  }

  componentDidMount() {
    this.props.phaseChange({ phase: 50 })
    if (!this.state.toTop) {
      animateScroll.scrollToTop()
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({ toTop: true })
    }

    if (this.props.customer && this.props.customer.token) {
      this.props
        .getFindomesticDocumentiClienteV1()
        .then(() => this.props.storeDumpItForce())
    }

    // BRUM-6741 si mostra subito l'help di come far le foto ai documenti
    setTimeout(() => this.props.toggleHelpDocumenti(true), 3000)
  }

  // eslint-disable-next-line no-unused-vars
  onDrop(acceptedFiles, fileRejections) {
    this.setState({ hasRejectedFiles: fileRejections.length > 0 })

    if (this.state.upload_btn_disabled) {
      this.setState({ upload_btn_disabled: acceptedFiles.length <= 0 })
    }
    this.props.findomesticFileUploadDropped({ dropzone: acceptedFiles })
  }

  onOpenClick(event) {
    event.stopPropagation()
    event.preventDefault()
    this.dropzone.open()
  }

  removeFile() {
    const that = this
    return e => {
      e.preventDefault()
      e.stopPropagation()
      that.props.findomesticFileUploadRemoved(
        e.target.id.replace('remove-', '')
      )
      if (that.props.findomesticFileUpload.dropzone.length === 0) {
        that.setState({ upload_btn_disabled: true })
      }
    }
  }

  handleCheckbox() {
    const that = this
    return event => {
      if (event.target.checked) {
        that.setState({ counter: that.state.counter + 1 })
      } else {
        that.setState({ counter: that.state.counter - 1 })
      }
    }
  }

  handleSubmit() {
    const t = this
    // BRUM-5806 reroute senza parametri fa solo il check disponibilita
    t.props.reroute().then(() => {
      if (!this.props.fetching) {
        if (!this.state.upload_btn_disabled) {
          this.props
            .postFindomesticFileUpload({
              dropzone: this.props.findomesticFileUpload.dropzone,
              token: this.props.customer.token,
              id_ordine: this.props.ordine.id_ordine,
            })
            .then(() => {
              triggerDataLayerEvent(GA_EVENTS.Purchase_finanziamento)
              fbPixel(FB_EVENTS.Purchase, t.props.product)
              t.props.phaseChange({
                last: t.props.ui.last > 50 ? t.props.ui.last : 50,
              })
              t.props.reroute('/thank-you-findomestic')
            })
            .catch(() => null)
        }
      }
    })
  }

  buildListaDocumentiNecessari() {
    const t = this
    let list = null
    if (t.props.findomestic.documenti_necessari) {
      if (t.props.findomestic.documenti_necessari.length > 0) {
        list = t.props.findomestic.documenti_necessari.map((documento, i) => (
          <li key={i}>
            <span className="document_name">
              <label className="r-checkbox">
                <input
                  onChange={this.handleCheckbox}
                  type="checkbox"
                  value="1"
                />
                {documento.label}
                <a className="upload-mobile">
                  <i className="icon-arrow_double_right"></i>
                </a>
              </label>
            </span>
          </li>
        ))
      }
    }
    return list
  }

  buildListaDocumentiSelezionatiPerUpload() {
    const t = this
    let list = null
    if (t.props.findomesticFileUpload) {
      if (t.props.findomesticFileUpload.dropzone.length > 0) {
        list = t.props.findomesticFileUpload.dropzone.map((documento, i) => (
          <li key={i}>
            <div className={'file_preview'}>
              <img src={documento.preview} />
            </div>
            <div className={'file_link'}>
              <a
                className={'file_link--label'}
                href={documento.preview}
                rel="noreferrer"
                target="_blank"
              >
                {documento.name}
              </a>
            </div>
            <span className={'file_remove'}>
              <a className="file_remove--link" onClick={this.removeFile()}>
                {' '}
                <i
                  className="icon-close file_remove--icon"
                  id={`remove-${i}`}
                ></i>
              </a>
            </span>
          </li>
        ))
      }
    }

    return list
  }

  render() {
    return (
      <div>
        <div className="process__header hide-print">
          <h1 className="process__title hide-print">Carica i tuoi documenti</h1>
          <p className="process__intro hide-print">
            Aiutaci a raccogliere i documenti che servono a completare il
            passaggio di proprietà.
          </p>
        </div>
        <div className={'messages warning'}>
          <div className={'container'}>
            <OrderRecoveryBanner />
          </div>
        </div>
        <div className="user-informations">
          <div className="container--small">
            <div className="documents__upload">
              <div className="documents__upload__left">
                <div className="documents_list">
                  <ul>
                    <li className="title">
                      <span className={'only-desktop'}>
                        Ciao{' '}
                        <span className={'user_name'} data-hj-suppress>
                          {this.props.customer.nome}
                        </span>
                        , &nbsp;carica i seguenti documenti:
                      </span>
                      <span className={'only-mobile'}>
                        Ciao{' '}
                        <span className={'user_name'} data-hj-suppress>
                          {this.props.customer.nome}
                        </span>
                        , &nbsp;ci servono questi documenti:
                      </span>
                    </li>

                    {this.buildListaDocumentiNecessari()}

                    <li className={'files__list'}>
                      <ul>
                        {this.props.findomesticFileUpload &&
                        this.props.findomesticFileUpload.dropzone.length > 0 ? (
                          <li className={'title small'}>Documenti caricati:</li>
                        ) : null}
                        {this.buildListaDocumentiSelezionatiPerUpload()}
                      </ul>
                    </li>

                    {this.state.hasRejectedFiles && <FileUploadErrorMessage />}

                    {this.props.findomesticFileUpload &&
                    this.props.findomesticFileUpload.dropzone.length > 0 ? (
                      <li className="last">
                        <a
                          className={
                            this.props.fetching ||
                            this.state.upload_btn_disabled
                              ? 'btn btn-primary btn-disabled'
                              : 'btn btn-primary'
                          }
                          data-cy="documents-submit"
                          onClick={this.handleSubmit}
                        >
                          <span>Ho completato l'upload!</span>
                        </a>
                      </li>
                    ) : null}
                  </ul>
                </div>
              </div>
              <div className="documents__upload__right">
                <DocumentiHelper
                  flowType={'buy-financing'}
                  onClick={() => this.props.toggleHelpDocumenti(true)}
                />
                <DropZone
                  accept="application/pdf,image/jpg,image/jpeg,image/png"
                  activeClassName="drag_accept"
                  className="drag_drop"
                  onDrop={this.onDrop}
                  ref={node => {
                    this.dropzone = node
                  }}
                  rejectClassName="drag_reject"
                >
                  {({ getRootProps, getInputProps }) => (
                    <div {...getRootProps()} className="drag_drop__content">
                      <input {...getInputProps()} data-cy="documents-file" />
                      <i className="icon-upload"></i>
                      <h2>Trascina qui i tuoi documenti</h2>
                      <span style={{ fontSize: '12px' }}>
                        (formati consentiti .jpg, .jpeg, .png, .pdf - max 50MB)
                      </span>
                    </div>
                  )}
                </DropZone>
                <div className="documents__upload__other">
                  <span className="documents__upload__other__or only-desktop">
                    <span>Oppure</span>
                  </span>
                  <div className="file-upload-box">
                    <div
                      className="fileUpload btn btn-secondary"
                      onClick={this.onOpenClick}
                    >
                      <span className={'only-desktop'}>Scegli un file</span>
                      <span className={'only-mobile'}>
                        Carica/Scatta una foto
                      </span>
                      <input className="upload" id="uploadBtn" type="file" />
                    </div>

                    {this.props.findomesticFileUpload &&
                    this.props.findomesticFileUpload.dropzone.length > 0 ? (
                      <div className="only-mobile">
                        <a
                          className={
                            this.props.fetching ||
                            this.state.upload_btn_disabled
                              ? 'btn btn-primary btn-disabled'
                              : 'btn btn-primary'
                          }
                          onClick={this.handleSubmit}
                        >
                          <span>Ho completato l'upload!</span>
                        </a>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
            <div className="contacts_list">
              <ul>
                <li className="title">
                  <span>
                    Problemi con l'upload?
                    <br />
                    Chiama il Servizio Clienti allo <b>02.800.29</b>
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

DocumentsFindomestic.propTypes = {
  customer: PropTypes.object,
  findomesticFileUpload: PropTypes.object,
  reroute: PropTypes.func,
  postFindomesticFileUpload: PropTypes.func,
  findomesticFileUploadDropped: PropTypes.func,
  findomesticFileUploadRemoved: PropTypes.func,
  getFindomesticDocumentiClienteV1: PropTypes.func,
  phaseChange: PropTypes.func,
  storeDumpItForce: PropTypes.func,
  fetching: PropTypes.bool,
  ordine: PropTypes.object,
  findomestic: PropTypes.object,
  buyHelper: PropTypes.func,
  toggleHelpDocumenti: PropTypes.func,
}
const mapStateToProps = state => ({
  findomesticFileUpload: state.findomesticFileUpload,
  compass_tabelledominio: state.compass_tabelledominio,
  customer: state.customer,
  findomestic: state.findomestic,
  ordine: state.ordine,
  fetching: state.ui.fetching,
  ui: state.ui,
  help: state.ui.buyHelper,
  product: state.product,
})

const mapDispatchToProps = dispatch => ({
  postFindomesticFileUpload: payload =>
    dispatch(postFindomesticFileUpload(payload)),
  findomesticFileUploadDropped: payload =>
    dispatch(findomesticFileUploadDropped(payload)),
  findomesticFileUploadRemoved: payload =>
    dispatch(findomesticFileUploadRemoved(payload)),
  phaseChange: payload => dispatch(phaseChange(payload)),
  storeDumpItForce: payload => dispatch(storeDumpItForce(payload)),
  reroute: payload => dispatch(reroute(payload)),
  getFindomesticDocumentiClienteV1: () =>
    dispatch(getFindomesticDocumentiClienteV1),
  buyHelper: () => dispatch(buyHelper()),
  toggleHelpDocumenti: newStatus => dispatch(toggleHelpDocumenti(newStatus)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DocumentsFindomestic)
